import MileageDownloadRequest, {
  MileageDownloadRequestOrder,
  MileageDownloadRequestTimezone,
} from "../../../api/raily/mileage/download/mileage-download.request";
import Timezone from "../../../types/timezone";
import MileageDownloadParams, {
  MileageDownloadParamsOrder,
} from "./mileage-download-params";

const createTimezone = (
  timezone: Timezone | undefined,
): MileageDownloadRequestTimezone | undefined => {
  switch (timezone) {
    case Timezone.EUROPE_WARSAW:
      return MileageDownloadRequestTimezone.EUROPE_WARSAW;
    case Timezone.UTC:
      return MileageDownloadRequestTimezone.UTC;
    default:
      return undefined;
  }
};

const createOrder = (
  order?: MileageDownloadParamsOrder,
): MileageDownloadRequestOrder | undefined => {
  switch (order) {
    case MileageDownloadParamsOrder.CARD_NO_ASC:
      return MileageDownloadRequestOrder.CARD_NO_ASC;
    case MileageDownloadParamsOrder.CARD_NO_DESC:
      return MileageDownloadRequestOrder.CARD_NO_DESC;
    case MileageDownloadParamsOrder.CARGO_COMPANY_NAME_ASC:
      return MileageDownloadRequestOrder.CARGO_COMPANY_NAME_ASC;
    case MileageDownloadParamsOrder.CARGO_COMPANY_NAME_DESC:
      return MileageDownloadRequestOrder.CARGO_COMPANY_NAME_DESC;
    case MileageDownloadParamsOrder.DATE_ASC:
      return MileageDownloadRequestOrder.DATE_ASC;
    case MileageDownloadParamsOrder.DATE_DESC:
      return MileageDownloadRequestOrder.DATE_DESC;
    case MileageDownloadParamsOrder.DISTANCE_ASC:
      return MileageDownloadRequestOrder.DISTANCE_ASC;
    case MileageDownloadParamsOrder.DISTANCE_DESC:
      return MileageDownloadRequestOrder.DISTANCE_DESC;
    case MileageDownloadParamsOrder.HUMAN_ID_ASC:
      return MileageDownloadRequestOrder.HUMAN_ID_ASC;
    case MileageDownloadParamsOrder.HUMAN_ID_DESC:
      return MileageDownloadRequestOrder.HUMAN_ID_DESC;
    case MileageDownloadParamsOrder.WORKER_LAST_NAME_ASC:
      return MileageDownloadRequestOrder.WORKER_LAST_NAME_ASC;
    case MileageDownloadParamsOrder.WORKER_LAST_NAME_DESC:
      return MileageDownloadRequestOrder.WORKER_LAST_NAME_DESC;
    case MileageDownloadParamsOrder.WORKER_NAME_ASC:
      return MileageDownloadRequestOrder.WORKER_NAME_ASC;
    case MileageDownloadParamsOrder.WORKER_NAME_DESC:
      return MileageDownloadRequestOrder.WORKER_NAME_DESC;
    default:
      return undefined;
  }
};

const create = (params: MileageDownloadParams): MileageDownloadRequest => {
  return {
    mileageUuids: params.mileageUuids,
    separator: params.separator,
    timezone: createTimezone(params.timezone),
    order: createOrder(params.order),
  };
};

const mileageDownloadParamsFactory = {
  create,
};

export default mileageDownloadParamsFactory;
